import { BaseService } from '../../infra/base.service'
import type { PaymentLink } from './payment-link.entity'
import type { PaymentLinksRepository } from './payment-links.repository'

export class PaymentLinksService extends BaseService<PaymentLink> {
    constructor(private rep: PaymentLinksRepository) {
        super(rep)
    }
}
